import { BaseResource } from 'utils/ApiUtils';

export default class FieldFormsResult extends BaseResource {
  constructor(args) {
    super(args, FieldFormsResult.attributes);
  };

  static columns = [
    { title: "Field Test ID", field: "FieldTestId", hidden: true, hiddenByColumnsButton: true, type: 'guid' },
    { title: "Date", field: "OccurenceDate", type: "date" },
    { title: "Inspection #", field: "InspectionNumber_Inspection" },
    { title: "Inspector", field: "Name_SystemUser" },
    { title: "Test Type", field: "TestType_Form" },
    { title: "Material Code", field: "MaterialCode_FieldMaterial" },
    { title: "Material Desc", field: "MaterialDesc_FieldMaterial" },
    { title: "Material Spec", field: "SpecItem_FieldMaterial" },
    { title: "Status", field: "Description_TestResults", defaultSort: 'asc' },
    { title: "Review Status", field: "Description_ReviewStatus", sorting: false, filter: false },
    { title: "Attachments", field: "XrefFieldTest", sorting: false, filter: false },
    { title: "Sample ID", field: "SampleCd", sorting: false, filter: false, hidden: true },
    { title: "Supplier", field: "Supplier_FieldMaterial", filter: false, hidden: true },
    { title: "Material Sub", field: "MaterialSub_FieldMaterial", filter: false, hidden: true },

  ]

  static attributes = FieldFormsResult.columns.map(r => r.field);

  static expand = [
    {
      "Ihwi": {
        expand: [
          {
            "Inspection": {
              select: ["InspectionNumber"]
            }
          },
          {
            "Inspection": {
              expand:
              {
                "Rassignment": {
                  expand:
                  {
                    "SystemUser": { "select": ["Name"] }
                  }
                }
              }
            }
          }
        ]
      },
      "MaterialForm": {
        "expand": [
          {
            "Form": {
              select: ["TestType"]
            }
          },
          {
            "FieldMaterial": {
              select: ["MaterialDesc", "MaterialCode", "MaterialCode", "SpecItem", "MaterialSub", "Supplier"]
            }
          }
        ]
      },
      "XrefFieldTest": {
        expand: {
          Artifact: {
            select: ["*"]
          }
        }
      },
      "SampleTestReviews": {
        expand: {
          ReviewStatus: {
            select: ["Description"]
          }
        }
      },
      "TestResults": {
        select: ["Description"]
      }
    }
  ]
};
